namespace $.$$ {
	export class $shm_dashboard_admin_book extends $.$shm_dashboard_admin_book {
		auth_state( key: string, next?: string ) {
			return this.$.$mol_state_local.value< string >( this.$.$shm_pb.admin_auth_store_key( key ), next ) ?? ''
		}

		auth_pb_url_override( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_arg.value( 'pb_url', next || null )
				return next
			}
			return this.$.$mol_state_arg.value( 'pb_url' )
				?? this.$.$mol_state_local.value< string >( this.$.$shm_pb.url_store_key() )
				?? ''
		}

		section( next?: string ) {
			const key = this.section_state_key()
			if( next !== undefined ) this.$.$mol_state_arg.value( key, next )
			const section = this.$.$mol_state_arg.value( key ) || 'users'
			return section === 'limits' ? 'wordstat' : section
		}

		users_current() { return this.section() === 'users' }
		wordstat_current() { return this.section() === 'wordstat' }
		monitoring_current() { return this.section() === 'monitoring' }
		server_current() { return this.section() === 'server' }

		section_arg( section: string ) {
			const fullscreen_widget = this.$.$mol_state_arg.value( 'fullscreen_widget' )
			return {
				...this.$.$mol_state_arg.dict(),
				[ this.section_state_key() ]: section,
				fullscreen_widget: fullscreen_widget || null,
			}
		}

		users_arg() { return this.section_arg( 'users' ) }
		wordstat_arg() { return this.section_arg( 'wordstat' ) }
		monitoring_arg() { return this.section_arg( 'monitoring' ) }
		server_arg() { return this.section_arg( 'server' ) }
		server_metric_history() { return this.Server().metric_history() }

		dashboard_url() {
			return this.Auth().dashboard_url()
		}

		superuser_title() {
			const profile = this.auth_state( 'email' ) || this.auth_state( 'user_id' ) || 'superuser'
			return `Superuser: ${ profile }`
		}

		version_data_default() {
			return {
				version: '-',
				date: '-',
			}
		}

		version_data() {
			return this.$.$mol_error_fence(
				()=> this.$.$mol_fetch.json( '/shm/dashboard/admin/app/_version.json', { cache: 'no-store' } ) as { version?: string, date?: string },
				()=> this.version_data_default(),
				promise => $mol_fail_hidden( promise ),
			)
		}

		version_data_version() {
			return String( this.version_data().version || this.version_data_default().version )
		}

		version_data_date() {
			return String( this.version_data().date || this.version_data_default().date )
		}

		menu_session_rows() {
			return [
				this.Dashboard_link(),
				this.$.$shm_pb.admin_authenticated() ? this.Superuser() : null,
				this.$.$shm_pb.admin_authenticated() ? this.Logout() : null,
			].filter( Boolean ) as readonly $mol_view[]
		}

		@ $mol_action
		logout( next?: Event ) {
			if( next === undefined ) return null
			this.auth_state( 'token', '' )
			this.auth_state( 'user_id', '' )
			this.auth_state( 'email', '' )
			this.Auth().password( '' )
			this.Auth().message( '' )
			this.$.$shm_pb.realtime_reset()
			return next
		}

		admin_pages() {
			if( !this.$.$shm_pb.admin_authenticated() ) return [ this.Menu(), this.Auth() ]
			const page = this.section() === 'server'
				? this.Server()
				: this.section() === 'wordstat'
				? this.Wordstat()
				: this.section() === 'monitoring'
					? this.Monitoring()
					: this.Users()
			return this.section() === 'server'
				? [ this.Menu(), page, this.Server_charts() ]
				: [ this.Menu(), page ]
		}
	}
}
